import { useCallback, useEffect, useState } from "react";
import { AppState } from "react-native";
import { fetchFlags } from "@src/services/feature-flags/feature-flags";

export interface UseAppReadinessReturn {
  /** False until boot (`useAppBoot`) has finished and the app can render its screens. */
  isReady: boolean;
  markReady: () => void;
}

/**
 * Boot state for the native root layout. Held above the providers so the layout
 * can gate on it, and set by `useAppBoot`, which runs inside them.
 */
export function useAppReadiness(): UseAppReadinessReturn {
  const [isReady, setIsReady] = useState(false);

  const markReady = useCallback(() => setIsReady(true), []);

  // Refresh flags each time the app returns to the foreground.
  useEffect(() => {
    if (!isReady) return;
    const subscription = AppState.addEventListener("change", (next) => {
      if (next === "active") void fetchFlags();
    });
    return () => subscription.remove();
  }, [isReady]);

  return { isReady, markReady };
}
